module.exports = __webpack_public_path__ + "img/mate-card_click.4921950.png";